import React from 'react';
import { ColumnContainer } from '../OperationListView.styles';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import StowageStatusIcon from 'src/components/ui/status-icon/StowageStatusIcon';
import { StowageStatusEnum } from 'src/enums/stowage/stowageStatusEnum';
import { isLoadingOrUnloadingCargoOperation } from 'src/utils/stowage/cargoOperationUtils';
import OperationStatusIcons from './OperationStatusIcons';

interface OperationStatusColumnProps {
    cargoOperation: RotationCargoOperation;
    violationType: StowageRuleConsequenceType | null;
    columnWidth: string | number;
    stowageStatus: StowageStatusEnum | null;
    onOpenOperationMenu: (e: React.MouseEvent) => void;
    onViewCargoOperation: () => void;
    onViewViolations: () => void;
}

/**
 * Renders the status icon column for an operation list item.
 * Displays operation status, violations, and interactive menu triggers.
 */
const OperationStatusColumn: React.FC<OperationStatusColumnProps> = ({
    cargoOperation,
    violationType,
    columnWidth,
    stowageStatus,
    onOpenOperationMenu,
    onViewCargoOperation,
    onViewViolations,
}) => {
    /**
     * Returns the status icon for the operation based on stowage status
     */
    const getOperationStatusIcon = (): JSX.Element | undefined => {
        if (!isLoadingOrUnloadingCargoOperation(cargoOperation) || stowageStatus === null) {
            return undefined;
        }

        return StowageStatusIcon(stowageStatus, null, cargoOperation.operationType as 'Loading' | 'Unloading');
    };

    return (
        <ColumnContainer className="col col-menu status-icon" width={typeof columnWidth === 'number' ? `${columnWidth}px` : columnWidth}>
            <OperationStatusIcons
                cargoOperation={cargoOperation}
                violationType={violationType}
                onOpenOperationMenu={onOpenOperationMenu}
                onViewCargoOperation={onViewCargoOperation}
                onViewViolationsForCargo={onViewViolations}
                getOperationStatusIcon={getOperationStatusIcon}
            />
        </ColumnContainer>
    );
};

export default OperationStatusColumn;
